/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1PricegrouppocketsQueryResponse } from '../../types/GetV1Pricegrouppockets.ts'

export const getV1PricegrouppocketsQueryKey = () => [{ url: '/v1/PriceGroupPockets' }] as const

export type GetV1PricegrouppocketsQueryKey = ReturnType<typeof getV1PricegrouppocketsQueryKey>

/**
 * {@link /v1/PriceGroupPockets}
 */
export async function getV1Pricegrouppockets(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1PricegrouppocketsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/PriceGroupPockets`, ...requestConfig })
    return res
}

export function getV1PricegrouppocketsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1PricegrouppocketsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1PricegrouppocketsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1PricegrouppocketsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Pricegrouppockets(config)
        },
    })
}

/**
 * {@link /v1/PriceGroupPockets}
 */
export function useGetV1Pricegrouppockets<
    TData = ResponseConfig<GetV1PricegrouppocketsQueryResponse>,
    TQueryData = ResponseConfig<GetV1PricegrouppocketsQueryResponse>,
    TQueryKey extends QueryKey = GetV1PricegrouppocketsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1PricegrouppocketsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1PricegrouppocketsQueryKey()

    const query = useQuery(
        {
            ...getV1PricegrouppocketsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
